module.exports = __webpack_public_path__ + "img/zoom.8e498439.svg";